import React from 'react';
import PropTypes from 'prop-types';
import { CmsComponent } from '@johnlewispartnership/wtr-content-component-library';
import { normaliseDeviceBreakpoints } from '@johnlewispartnership/wtr-content-component-library/dist/component-library/components/CmsComponentGrid/normalise-device-breakpoints';

import {
  AemComponentEntity,
  ProductEntity,
  SponsoredBannerEntity,
} from 'constants/data-shapes/product-entity';

import ProductPod from 'components/ProductPod';
import { transformSearchResultToCitrusTradingCell } from 'utils/adtech/transform-searchresult-to-tradingcell-props';
import TradingCell from 'content/components/TradingCellWrapper';

const nullEntity = () => null;

const gridComponentDefaultPropPositions = {};

const GridComponent = ({
  autoFocus = false,
  index = 0,
  isBuilderPage = false,
  item = null,
  listId,
  searchType = null,
  taxonomyLevel = null,
  positions = gridComponentDefaultPropPositions,
  listDefinitions,
}) => {
  if (item?.searchProduct) {
    const { cqResponsive, searchProduct: id, sponsored, sponsorshipId, tracking } = item;

    return (
      <ProductPod
        {...{
          autoFocus,
          positions,
          taxonomyLevel,
          searchType,
          index,
          isBuilderPage,
          cqResponsive,
          listId,
          key: `${JSON.stringify(positions)}${id}`,
          id,
          sponsored,
          sponsorshipId,
          tracking,
          listDefinitions,
        }}
      />
    );
  }

  if (item?.aemComponent) {
    return (
      <CmsComponent
        {...{
          component: normaliseDeviceBreakpoints(item.aemComponent),
          position: `grid-${index + 1}`,
          positions,
          searchType,
          index,
          taxonomyLevel,
        }}
      />
    );
  }

  if (item?.sponsoredBanner) {
    return (
      <TradingCell
        {...transformSearchResultToCitrusTradingCell({
          index,
          position: `grid-${index + 1}`,
          component: item.sponsoredBanner,
          searchType: searchType ?? '',
        })}
      />
    );
  }

  return null;
};

GridComponent.propTypes = {
  autoFocus: PropTypes.bool,
  index: PropTypes.number,
  isBuilderPage: PropTypes.bool,
  item: PropTypes.oneOfType([
    AemComponentEntity(),
    ProductEntity(),
    SponsoredBannerEntity(),
    nullEntity,
  ]),
  listId: PropTypes.string,
  searchType: PropTypes.string,
  taxonomyLevel: PropTypes.string,
  positions: PropTypes.shape({}),
  listDefinitions: PropTypes.shape({
    curation: PropTypes.string,
    format: PropTypes.string,
    page: PropTypes.string,
    title: PropTypes.string,
  }),
};

export default GridComponent;
